import React, { Component, isValidElement } from 'react';
import PropTypes from 'prop-types';

import { Flex } from '../../units/Box/Box';
import { Title, CloseIcon } from './ModalUnits';

class ModalHeader extends Component {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    size: PropTypes.oneOf(['normal', 'small']),
    margin: PropTypes.string,
    onClose: PropTypes.func
  };

  static defaultProps = {
    title: null,
    size: 'normal',
    margin: '0 0 25px 0',
    onClose: null
  };

  close = () => {
    this.props.onClose();
  };

  render() {
    if (!this.props.title && !this.props.onClose) return null;

    let title;
    if (typeof this.props.title === 'string') {
      title = <Title size={this.props.size}>{this.props.title}</Title>;
    } else if (isValidElement(this.props.title)) {
      title = this.props.title;
    } else {
      title = null;
    }

    return (
      <Flex justify="space-between" align="center" m={this.props.margin}>
        {title}
        {this.props.onClose && (
          <CloseIcon
            className="btn-popup-close"
            size={this.props.size}
            onClick={this.close}
            pointer
          />
        )}
      </Flex>
    );
  }
}

export default ModalHeader;



// WEBPACK FOOTER //
// ./src/components/units/Modal/Header.js